import script from "./ResumeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeSection.vue?vue&type=script&setup=true&lang=js"

import "./ResumeSection.vue?vue&type=style&index=0&id=0b262079&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b262079"]])

export default __exports__